module.exports = __webpack_public_path__ + "img/checklist-red.1d0697e9.svg";